import React, {
  lazy,
  Suspense,
  useEffect,
  useMemo,
  useRef,
  useState,
  MouseEvent,
} from "react";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { DotLottieReact } from "@lottiefiles/dotlottie-react";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import BrowserUpdatedIcon from "@mui/icons-material/BrowserUpdated";
// import { Broker } from "./interface";
import "./InputBox.scss";
import HistoryIcon from "@mui/icons-material/History";
import {
  MaterialReactTable,
  // createRow,
  type MRT_ColumnDef,
  MRT_ColumnFiltersState,
  MRT_DensityState,
  type MRT_Row,
  MRT_SortingState,
  type MRT_TableOptions,
  MRT_ToggleFiltersButton,
  MRT_ToggleFullScreenButton,
  MRT_VisibilityState,
  useMaterialReactTable,
} from "material-react-table";
import {
  Box,
  Button,
  IconButton,
  Menu,
  MenuItem,
  TextField,
  Tooltip,
} from "@mui/material";
import {
  QueryClient,
  QueryClientProvider,
  useMutation,
  useQuery,
  useQueryClient,
} from "@tanstack/react-query";
import { type User } from "./makeData";

import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import Accordion from "react-bootstrap/Accordion";
import Table from "react-bootstrap/Table";
import { Col, Container, Form, Row } from "reactstrap";
import axiosInstance from "../../Utils/axiosInstance";
import { backendbaseUrl } from "../../Utils/baseUrl";
import { toast } from "react-toastify";
import { StyledTableFirstSecond } from "../Book/TableBook";
import { fakeData } from "./makeData";
import { showDeleteConfirmModal } from "../../Components/ConfirmModal";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import BrokerTemplateDownloadButton from "../../Components/TemplateDownloadButton/BrokerTemplateDownloadButton";
import { TableColumnVisibilityMenu } from "../../Components/SharedComponents/TableColumnVisibilityMenu";
import { CommonToolbarInternalActions } from "../../Components/SharedComponents/CommonTableToolbarActions";
import { MRT_COLUMN_FILTERS_CONTRACT, MRT_COLUMN_VISIBILITY_CONTRACT, MRT_DENSITY_CONTRACT, MRT_GLOBAL_FILTERS_CONTRACT, MRT_SHOW_COLUMN_FILTERS_CONTRACT, MRT_SHOW_GLOBAL_FILTERS_CONTRACT, MRT_SORTING_CONTRACT } from "../../Constants/TableFilter.constants";

const ContractFormTableComponent = ({
  dataVersion,
  setDataVersion,
  setCopiedData,
  setEditMode,
  setEditedData,
}: {
  dataVersion: number;
  setDataVersion: React.Dispatch<React.SetStateAction<number>>;
  setCopiedData: any;
  setEditMode: any;
  setEditedData: any;
}) => {
  // useEffect(() => {
  //   queryClient.invalidateQueries({ queryKey: ["users"] });
  //   queryClient.refetchQueries({ queryKey: ["users"] });
  // }, [contractCreated]);

  const [validationErrors, setValidationErrors] = useState<
    Record<string, string | undefined>
  >({});
  const isFirstRender = useRef(true);
  const [filterModes, setFilterModes] = useState<
    { mode: string; id: string; value: unknown }[]
  >([]);

  const [columnFilters, setColumnFilters] = useState<MRT_ColumnFiltersState>(
    []
  );
  const [columnVisibility, setColumnVisibility] = useState<MRT_VisibilityState>(
    {}
  );
  const [density, setDensity] = useState<MRT_DensityState>("comfortable");
  const [globalFilter, setGlobalFilter] = useState<string | undefined>(
    undefined
  );
  const [showGlobalFilter, setShowGlobalFilter] = useState(true);
  const [showColumnFilters, setShowColumnFilters] = useState(true);
  const [sorting, setSorting] = useState<MRT_SortingState>([]);
  const [brokerName, setBrokerName] = useState<string>("");
  const [inputBackgroundColour, setInputBackgroundColour] = useState("");
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 15, //set different default page size by initializing the state here
  });

  const addButtonRef = useRef<HTMLButtonElement | null>(null);
  const [showRowResizing, setShowRowResizing] = useState<boolean>(true);
  const [totalCount, setTotalCount] = useState(0);
  useEffect(() => {
    //do something when the pagination state changes
  }, [pagination]);

  useEffect(() => {
    const columnFilters = sessionStorage.getItem(MRT_COLUMN_FILTERS_CONTRACT);
    const columnVisibility = sessionStorage.getItem(
      MRT_COLUMN_VISIBILITY_CONTRACT
    );
    const density = sessionStorage.getItem(MRT_DENSITY_CONTRACT);
    const globalFilter = sessionStorage.getItem(MRT_GLOBAL_FILTERS_CONTRACT);
    const showGlobalFilter = sessionStorage.getItem(
      MRT_SHOW_GLOBAL_FILTERS_CONTRACT
    );
    const showColumnFilters = sessionStorage.getItem(
      MRT_SHOW_COLUMN_FILTERS_CONTRACT
    );
    const sorting = sessionStorage.getItem(MRT_SORTING_CONTRACT);

    if (columnFilters) {
      setColumnFilters(JSON.parse(columnFilters));
    }
    if (columnVisibility) {
      setColumnVisibility(JSON.parse(columnVisibility));
    }
    if (density) {
      setDensity(JSON.parse(density));
    }
    if (globalFilter) {
      setGlobalFilter(JSON.parse(globalFilter) || undefined);
    }
    if (showGlobalFilter) {
      setShowGlobalFilter(JSON.parse(showGlobalFilter));
    }
    if (showColumnFilters) {
      setShowColumnFilters(JSON.parse(showColumnFilters));
    }
    if (sorting) {
      setSorting(JSON.parse(sorting));
    }
    isFirstRender.current = false;
  }, []);

  //save states to local storage
  useEffect(() => {
    if (isFirstRender.current) return;
    sessionStorage.setItem(
      MRT_COLUMN_FILTERS_CONTRACT,
      JSON.stringify(columnFilters)
    );
  }, [columnFilters]);
  //save states to local storage
  useEffect(() => {
    if (isFirstRender.current) return;
    sessionStorage.setItem(
      MRT_COLUMN_FILTERS_CONTRACT,
      JSON.stringify(columnFilters)
    );

    console.log("columnFilters", "columnFilters---------------", columnFilters);
  }, [columnFilters]);

  useEffect(() => {
    if (isFirstRender.current) return;
    sessionStorage.setItem(
      MRT_COLUMN_VISIBILITY_CONTRACT,
      JSON.stringify(columnVisibility)
    );
  }, [columnVisibility]);

  useEffect(() => {
    if (isFirstRender.current) return;
    sessionStorage.setItem(MRT_DENSITY_CONTRACT, JSON.stringify(density));
  }, [density]);

  useEffect(() => {
    if (isFirstRender.current) return;
    sessionStorage.setItem(
      MRT_GLOBAL_FILTERS_CONTRACT,
      JSON.stringify(globalFilter ?? "")
    );
  }, [globalFilter]);

  useEffect(() => {
    if (isFirstRender.current) return;
    sessionStorage.setItem(
      MRT_SHOW_GLOBAL_FILTERS_CONTRACT,
      JSON.stringify(showGlobalFilter)
    );
  }, [showGlobalFilter]);

  useEffect(() => {
    if (isFirstRender.current) return;
    sessionStorage.setItem(
      MRT_SHOW_COLUMN_FILTERS_CONTRACT,
      JSON.stringify(showColumnFilters)
    );
  }, [showColumnFilters]);

  useEffect(() => {
    if (isFirstRender.current) return;
    sessionStorage.setItem(MRT_SORTING_CONTRACT, JSON.stringify(sorting));
  }, [sorting]);
  // Utility to create a default column configuration
  const createColumnConfig = (
    accessorKey: string,
    header: string,
    overrides: Partial<MRT_ColumnDef<any>> = {}
  ): MRT_ColumnDef<any> => ({
    accessorKey,
    header,
    enableEditing: true,
    filterVariant: "text",

    muiTableBodyCellProps: ({ row, table }) => ({
      onDoubleClick: (e) => e.stopPropagation(),
      sx: {
        cursor: "pointer",
        "&:hover": {
          backgroundColor: "rgba(44, 4, 4, 0.05)",
        },
        ...(table.getState().editingRow?.id === row.id && {
          backgroundColor: "rgba(0, 128, 0, 0.1)",
          transition: "background-color 0.3s ease",
        }),
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
      },
    }),
    muiEditTextFieldProps: {
      name: accessorKey, // Use accessorKey for validation to avoid hardcoded "name"
      required: true,
      error: !!validationErrors?.[accessorKey],
      helperText: validationErrors?.[accessorKey],
      onFocus: () =>
        setValidationErrors((prev) => ({
          ...prev,
          [accessorKey]: undefined,
        })),
    },
    ...overrides,
  });
  const columns = useMemo<MRT_ColumnDef<User>[]>(
    () => [
      createColumnConfig("derivatives", "Derivatives", {
        muiTableBodyCellProps: {
          className: "derivative-cell",
          onDoubleClick: (e) => e.stopPropagation(),
        },
      }),

      createColumnConfig("single_diff", "Single/Diff", {}),
      createColumnConfig("major_mini", "Major/Mini", {}),
      createColumnConfig("full_bal_month", "Full/Ball Month", {}),
      createColumnConfig("contract_name", "Contract Name", {}),
      createColumnConfig("contract1_name", "Contract 1", {}),
      createColumnConfig("contract2_name", "Contract 2", {}),
      createColumnConfig(
        "futures_equivalent_contract_name",
        "Futures Equivalent Contract",
        {}
      ),
      createColumnConfig(
        "major_mini_connection_name",
        "Major mini connection",
        {}
      ),
      createColumnConfig(
        "bal_month_connection_name",
        "Bal Month Connection",
        {}
      ),
      createColumnConfig("unit_name", "Unit", {}),
      createColumnConfig("tick", "Tick", {}),
      createColumnConfig("holiday_name", "Holiday", {}),
      createColumnConfig("kbbl_conversion_value", "BBL Conversion Value", {}),
      createColumnConfig("price_unit_name", "Price Unit", {}),
      createColumnConfig("price_conversion", "Price conversion Value", {}),
      createColumnConfig("f_w_months", "F.W months", {}),
      createColumnConfig("exchange_fees", "Exchange Fees", {}),
      createColumnConfig(
        "exchange_clearance_fees",
        "Exchange Clearance Fees",
        {}
      ),
      createColumnConfig("exchange_fees_blocked", "Exchange Fees Blocked", {}),
      createColumnConfig(
        "exchange_clearance_fees_blocked",
        "Exchange Clearance Fees Blocked",
        {}
      ),
      createColumnConfig("screen_fees", "Screen Fee", {}),
      createColumnConfig(
        "ice_clearer_eu_screen_fees",
        "Ice Clearer Eu Screen Fees",
        {}
      ),
      createColumnConfig(
        "ice_clearer_eu_block_fee",
        "Ice Clearer Eu Block Fees",
        {}
      ),
      createColumnConfig("cash_settle", "Cash Settle", {}),
      createColumnConfig("gimfc_code", "GMIFC Code", {}),
      createColumnConfig("physical_code", "Physical code", {}),
      createColumnConfig("logical_code", "Logical code", {}),
      createColumnConfig("symbol_code", "Symbol code", {}),
      createColumnConfig("platts_code", "Platts code", {}),
    ],
    [validationErrors]
  );

  //call CREATE hook
  const { mutateAsync: createUser, isPending: isCreatingUser } =
    useCreateUser();
  //call READ hook
  const {
    data,
    isError: isLoadingUsersError,
    isFetching: isFetchingUsers,
    isLoading: isLoadingUsers,
  } = useGetData(pagination, setTotalCount, sorting, dataVersion); // Pass dataVersion
  //call UPDATE hook

  // Add debug logging to verify data fetching
  useEffect(() => {
    console.log("useGetData triggered with data:", data);
  }, [data]);

  console.log(data, "data");
  const { mutateAsync: updateUser, isPending: isUpdatingUser } =
    useUpdateUser();
  //call DELETE hook
  const { mutateAsync: deleteUser, isPending: isDeletingUser } =
    useDeleteUser(setDataVersion);

  // CREATE FUNCTION TO ADD NEW A BROKER

  //UPDATE action
  const handleeditsave: MRT_TableOptions<User>["onEditingRowSave"] = async ({
    values,
    table,
    row, // Add row parameter to access full row data
  }) => {
    // Log the detailed values and table object
    console.log("Saving User - Full Row Original Data:", row.original);
    console.log("Saving User - Edited Values:", values);

    // Merge the edited values with the original row data
    const updatedUser = {
      ...row.original, // Spread the original row data first
      ...values, // Overlay the edited values on top
    };

    console.log("Saving User - Merged User Data:", updatedUser);

    // Validate user data
    const newValidationErrors = validateUser(updatedUser);

    // Check for validation errors
    if (Object.values(newValidationErrors).some((error) => error)) {
      console.log("Validation Errors:", newValidationErrors);
      setValidationErrors(newValidationErrors);
      return;
    }

    // Clear previous validation errors
    setValidationErrors({});

    // Trigger user update mutation
    try {
      await updateUser(updatedUser); // Pass the full, merged user object

      // Exit editing mode
      table.setEditingRow(null);
    } catch (error) {
      console.error("User Update Error:", error);
    }
  };

  //DELETE action
  const openDeleteConfirmModal = (row: MRT_Row<User>) => {
    showDeleteConfirmModal({
      title: "Are you sure you want to delete this Contract?",
      content: "Deleting...",
      onOk: () => {
        deleteUser(row.original.id)
          .then(() => {
            toast.success("Contract deleted successfully!");
          })
          .catch((error) => {
            toast.error("Failed to delete user. Please try again.");
          });
      },
    });
  };

  const contractEditFunctionality = (row: any) => {
    const rowData = row.original; // Get the row data
    let textToCopy = JSON.stringify(rowData, null, 2); // Convert to formatted JSON
    if (navigator?.clipboard?.writeText) {
      navigator.clipboard.writeText(textToCopy).catch((err) => {
        console.error("Clipboard write failed:", err);
      });
    } else {
      const textarea = document.createElement("textarea");
      textarea.value = textToCopy;
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand("copy");
      document.body.removeChild(textarea);
    } // Copy to clipboard
    setCopiedData(rowData);

    setEditMode(true);
    setEditedData(rowData);
  };

  const handleCopyRow = (row: any) => {
    if (!row) return;
    const rowData = row.original; // Get the row data
    let textToCopy = JSON.stringify(rowData, null, 2); // Convert to formatted JSON
    if (navigator?.clipboard?.writeText) {
      navigator.clipboard.writeText(textToCopy).catch((err) => {
        console.error("Clipboard write failed:", err);
      });
    } else {
      const textarea = document.createElement("textarea");
      textarea.value = textToCopy;
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand("copy");
      document.body.removeChild(textarea);
    } // Copy to clipboard
    setCopiedData(rowData);
    setEditMode(false);

    let jsonData;

    try {
      jsonData = JSON.parse(textToCopy);
      setBrokerName(jsonData.name);
      window.scrollTo({ top: 0, behavior: "smooth" });

      toast.success("copied and pasted successfully");

      setInputBackgroundColour("#83bf6e26");
      setTimeout(() => {
        setInputBackgroundColour(""); // Then set it again
      }, 2400);
    } catch (error) {
      console.error("Invalid JSON. Pasted as a string:", textToCopy);
      jsonData = { rawText: textToCopy }; // Fallback if not valid JSON
    }
  };

  interface ContextMenuPosition {
    mouseX: number;
    mouseY: number;
  }

  const [contextMenu, setContextMenu] = useState<ContextMenuPosition | null>(
    null
  );

  // Function to handle right-click and open the menu
  const handleContextMenu = (event: MouseEvent<HTMLDivElement>) => {
    event.preventDefault();
    setContextMenu(
      contextMenu === null
        ? { mouseX: event.clientX + 2, mouseY: event.clientY - 6 }
        : null
    );
  };

  // Function to handle menu close
  const handleClose = () => {
    setContextMenu(null);
  };

  // Function to handle Paste action
  const handlePaste = async () => {
    try {
      const text = await navigator.clipboard.readText();
      let jsonData;

      try {
        jsonData = JSON.parse(text);
        setBrokerName(jsonData.name);
        window.scrollTo({ top: 0, behavior: "smooth" });

        toast.success("copieds and pasted successfully");
        setInputBackgroundColour("#83bf6e26");
        setTimeout(() => {
          setInputBackgroundColour(""); // Then set it again
        }, 2400);
      } catch (error) {
        console.error("Invalid JSON. Pasted as a string:", text);
        jsonData = { rawText: text }; // Fallback if not valid JSON
      }

      // Here, you can use jsonData further as needed
    } catch (err) {
      console.error("Failed to read clipboard contents:", err);
    }

    handleClose();
  };

  // Function to handle Mark action
  const handleResizing = () => {
    setShowRowResizing(!showRowResizing);
    handleClose();
  };

  const navigate = useNavigate();
  const handlehistory = () => {
    navigate("/settings/log/history/contractsCustomer");
  };

  const handleExportRows = (rows: MRT_Row<any>[]) => {
    const rowData = rows.map((row) => row.original);
    console.log(rowData);
  };

  const handleDataDownload = async () => {
    try {
      const response = await axiosInstance.get(
        `${backendbaseUrl}/paper-app/contracts/export-delete/`,
        {
          responseType: "blob",
          headers: {
            // Add any required headers
            "Content-Type": "application/json",
          },
        }
      );

      // Check if response is valid
      if (!response.data) {
        throw new Error("No data received from server");
      }

      // Create download link
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "all_contracts.csv");
      document.body.appendChild(link);
      link.click();

      // Cleanup
      setTimeout(() => {
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      }, 100);

      toast.success("All Contract data downloaded");
    } catch (error) {
      console.error("Download error:", error);
      toast.error("Failed to download all data");
    }
  };
  const handleBulkDelete = async (rows: MRT_Row<any>[]) => {
    const rowIds = rows.map((row) => row.original.id);

    if (rowIds.length === 0) {
      toast.warn("Please select at least one contract to delete.");
      return;
    }

    console.log("Selected IDs for deletion:", rowIds);

    try {
      showDeleteConfirmModal({
        title: `Delete ${rowIds.length} selected contract(s)?`,
        content: `This will permanently delete ${rowIds.length} contract(s). Continue?`,
        onOk: async () => {
          const loadingToast = toast.loading(
            `Deleting ${rowIds.length} contract(s)...`
          );
          const payload = {
            ids: rowIds.filter((id) => id),
          };

          try {
            const response = await axiosInstance.delete(
              `${backendbaseUrl}/paper-app/contracts/export-delete/`,
              {
                data: payload,
                headers: {
                  "Content-Type": "application/json",
                  "X-Requested-With": "XMLHttpRequest",
                },
              }
            );

            if (response.status === 200) {
              toast.success(
                `Successfully deleted ${rowIds.length} contract(s)`
              );
              queryClient.invalidateQueries({ queryKey: ["users"] });
              table.setRowSelection({});
              setDataVersion((prev) => prev + 1); // Increment dataVersion
            } else {
              throw new Error(
                response.data?.message || "Unknown error occurred"
              );
            }
          } catch (error: any) {
            console.error("Delete error details:", {
              message: error.message,
              response: error.response?.data,
              status: error.response?.status,
            });

            const errorMessage =
              error.response?.data?.detail ||
              error.response?.data?.message ||
              error.message ||
              "Failed to delete contracts";

            toast.error(`Deletion failed: ${errorMessage}`);
          } finally {
            toast.dismiss(loadingToast);
          }
        },
      });
    } catch (error) {
      console.error("Confirmation dialog error:", error);
      toast.error("An error occurred during the deletion process.");
    }
  };
  const table = useMaterialReactTable({
    columns,

    enableStickyHeader: true,
    enableStickyFooter: true,
    enableClickToCopy: true,
    enableKeyboardShortcuts: true,
    // enableRowNumbers: true,
    enableColumnActions: true,
    enableColumnDragging: true,
    enableGlobalFilter: true,
    enableGrouping: true,
    enableHiding: true,
    enableSorting: true,
    enableColumnPinning: true,
    onPaginationChange: setPagination,
    onColumnFiltersChange: setColumnFilters,
    onColumnVisibilityChange: setColumnVisibility,
    onDensityChange: setDensity,
    onGlobalFilterChange: setGlobalFilter,
    onShowColumnFiltersChange: setShowColumnFilters,
    onShowGlobalFilterChange: setShowGlobalFilter,
    onSortingChange: setSorting,
    manualSorting: true,
    manualPagination: true,
    enableRowSelection: true,
    // positionToolbarAlertBanner: "bottom",
    // layoutMode: "semantic",
    // layoutMode: "grid",
    enableColumnResizing: true, // Already set
    // columnResizeMode: "onEnd", // Ensures precise resizing
    // defaultColumn: {
    //   minSize: 50, // Smallest practical width
    //   enableResizing: true,
    // },
    // enableColumnResizing: showRowResizing,
    enableFilterMatchHighlighting: true,
    rowCount: totalCount,
    manualFiltering: false,
    data: data?.results || [],
    enableDensityToggle: false,
    createDisplayMode: "row", // ('modal', and 'custom' are also available)
    // editDisplayMode: "row", // ('modal', 'cell', 'table', and 'custom' are also available)
    enableEditing: true,
    // editDisplayMode:"custom",
    // Top toolbar customization
    muiTopToolbarProps: ({ table }) => ({
      sx: {
        backgroundColor: "#fff",
        padding: "8px",
        // Optional: Style the inner MuiBox-root (css-wsew38) for visual confirmation
        "& .MuiBox-root.css-wsew38": {
          backgroundColor: "#fff",
          display: "flex",
          alignItems: "center",
          gap: "8px",
        },
      },
      className: "top-toolbar-wrapper__new",
    }),

    muiTableContainerProps: ({ table }) => ({
      sx: {
        backgroundColor: "#fff",
      },
      className: "table-container-wrapper__new",
    }),
    muiTableFooterProps: ({ table }) => ({
      sx: {
        backgroundColor: "#fff",
      },
      className: "table-footer-wrapper__new",
    }),
    muiBottomToolbarProps: ({ table }) => ({
      sx: {
        backgroundColor: "#fff",
        padding: "8px",
      },
      className: "bottom-toolbar-wrapper__new",
    }),

    muiTableBodyRowProps: ({ row, table }) => {
      // Define color mapping for derivative values
      const derivativeColors: Record<string, string> = {
        swaps: "transparent", // Light green for swaps
        futures: "transparent", // Light blue for futures
        // Add more derivative types and colors as needed
        default: "transparent", // Fallback color
      };

      // Get the derivative value from the row
      const derivative = row.getValue("derivatives") as string;
      const backgroundColor =
        derivativeColors[derivative] || derivativeColors.default;

      return {
        onKeyDown: (event: React.KeyboardEvent<HTMLTableRowElement>) => {
          if (event.key === "Enter") {
            event.preventDefault();
            const editingRow = table.getState().editingRow;
            if (editingRow) {
              const saveHandler = table.options.onEditingRowSave;
              if (saveHandler) {
                const newedit = {
                  ...editingRow.original,
                  ...editingRow._valuesCache,
                };
                saveHandler({
                  exitEditingMode: () => table.setEditingRow(null),
                  row: editingRow,
                  table,
                  values: newedit,
                });
              }
            }
          }
        },
        sx: {
          backgroundColor, // Apply dynamic background color
          "&:hover": {
            backgroundColor: `color-mix(in srgb, ${backgroundColor}, #000000 10%)`, // Slightly darker on hover
          },
          ...(table.getState().editingRow?.id === row.id && {
            backgroundColor: "rgba(0, 128, 0, 0.1)", // Override for editing row
            transition: "background-color 0.3s ease",
          }),
        },
      };
    },
    enableColumnOrdering: true, // ✅ Enables column drag-and-drop
    enableRowOrdering: false, // ✅ Enables row drag-and-drop
    getRowId: (row) => row.id,
    enableColumnFilterModes: true, //enable changing filter mode for all columns unless explicitly disabled in a column def
    initialState: { showColumnFilters: showColumnFilters }, 
    filterFns: {
      customFilterFn: (row, id, filterValue) => {
        return row.getValue(id) === filterValue;
      },
    },

    // defaultDisplayColumn: {
    //   enableResizing: true, //turn on some features that are usually off for all display columns
    // },
    displayColumnDefOptions: {
      "mrt-row-actions": {
        enableColumnActions: true,
        size: 120, //set custom width
        muiTableHeadCellProps: {
          // align: "center", //change head cell props
        },
      },
      "mrt-row-numbers": {
        enableColumnDragging: true,
        enableColumnOrdering: true, //turn on some features that are usually off
        // enableResizing: true,
        muiTableHeadCellProps: {
          sx: {
            fontSize: "1.2rem",
          },
        },
      },
      "mrt-row-select": {
        enableColumnActions: true,
        enableHiding: true,
        // size: 50,
      },
    },
    renderToolbarInternalActions: (props) => <CommonToolbarInternalActions {...props} />,
    renderTopToolbarCustomActions: ({ table }) => (
      <Box
        sx={{
          display: "flex",
          gap: "16px",
          padding: "8px",
          flexWrap: "wrap",
          alignItems: "center",
        }}
      >
        {/* Hidden file input */}
        <input
          type="file"
          accept=".csv"
          id="upload-csv"
          style={{ display: "none" }}
          onChange={(e) => {
            const file = e.target.files?.[0];
            if (file) {
              const formData = new FormData();
              formData.append("file", file);

              axiosInstance
                .post("/paper-app/upload-contracts/", formData, {
                  headers: { "Content-Type": "multipart/form-data" },
                })
                .then((res) => {
                  Swal.fire({
                    icon: "success",
                    title: "Import Successful",
                    text: "Contracts uploaded successfully!",
                    timer: 1500,
                    showConfirmButton: false,
                  });
                })
                .catch((err) => {
                  Swal.fire({
                    icon: "error",
                    title: "Import Failed",
                    text:
                      err?.response?.data?.message || "Error uploading file",
                  });
                })
                .finally(() => {
                  e.target.value = ""; // reset file input
                });
            }
          }}
        />

        {/* Import Button */}
        <Button
          variant="text"
          color="success"
          startIcon={<UploadFileIcon />}
          onClick={() => document.getElementById("upload-csv")?.click()}
          sx={{
            textTransform: "none",
            fontSize: "0.75rem",
            py: 0.8,
            px: 1.2,
            borderRadius: "6px",
          }}
        >
          Import CSV
        </Button>

        {/* Export All Data */}
        <Button
          onClick={() => handleDataDownload()}
          startIcon={<BrowserUpdatedIcon />}
          sx={{
            textTransform: "none",
            fontSize: "0.75rem",
          }}
        >
          Export All Data
        </Button>
        <BrokerTemplateDownloadButton
          apiEndpoint="/paper-app/download-contract-template/"
          buttonText="Download Template"
          fileName="contract_template.csv"
        />
        {/* History */}
        <Button
          onClick={() => handlehistory()}
          startIcon={<HistoryIcon />}
          sx={{
            textTransform: "none",
            fontSize: "0.75rem",
          }}
        >
          History
        </Button>

        {/* Export Selected Rows */}
        <Button
          disabled={
            !table.getIsSomeRowsSelected() && !table.getIsAllRowsSelected()
          }
          onClick={() => handleExportRows(table.getSelectedRowModel().rows)}
          startIcon={<FileDownloadIcon />}
          sx={{
            textTransform: "none",
            fontSize: "0.75rem",
          }}
        >
          Export Selected Rows
        </Button>

        {/* Delete Selected */}
        {(table.getIsSomeRowsSelected() || table.getIsAllRowsSelected()) && (
          <Button
            color="error"
            onClick={() => handleBulkDelete(table.getSelectedRowModel().rows)}
            startIcon={<DeleteIcon />}
            sx={{
              textTransform: "none",
              fontSize: "0.75rem",
            }}
          >
            Delete Selected ({table.getSelectedRowModel().rows.length})
          </Button>
        )}
      </Box>
    ),

    // muiTableProps: {
    //   sx: {
    //     border: '1px solid rgba(81, 81, 81, .5)',
    //     caption: {
    //       captionSide: 'top',
    //     },
    //   },
    // },
    muiTableHeadCellProps: {
      sx: {
        border: "1px solid #e0e0e087",
        fontStyle: "normal",
        fontWeight: "normal",
      },
    },

    muiTablePaperProps: {
      elevation: 0,
      sx: {
        borderRadius: "0",
        border: "0",
      },
    },
    localization: {
      filterCustomFilterFn: "Custom Filter Fn",
    } as any,

    muiToolbarAlertBannerProps: isLoadingUsersError
      ? {
          color: "error",
          children: "Error loading data",
        }
      : undefined,

    onCreatingRowCancel: () => setValidationErrors({}),
    // onCreatingRowSave:,
    onEditingRowCancel: () => setValidationErrors({}),
    onEditingRowSave: handleeditsave,

    renderRowActions: ({ row, table }) => (
      <Box
      //  sx={{ display: "flex", gap: "1rem" }}
      >
        <Tooltip title="Edit" className="editIcon">
          <IconButton onClick={() => contractEditFunctionality(row)}>
            <EditIcon />
          </IconButton>
        </Tooltip>
        <Tooltip title="Delete" className="deleteIcon">
          <IconButton color="error" onClick={() => openDeleteConfirmModal(row)}>
            <DeleteIcon />
          </IconButton>
        </Tooltip>
        <Tooltip title="Copy Row">
          <IconButton onClick={() => handleCopyRow(row)}>
            {" "}
            {/* ✅ Pass row as argument */}
            <ContentCopyIcon />
          </IconButton>
        </Tooltip>
      </Box>
    ),

    state: {
      columnVisibility,
      sorting,
      columnFilters,
      pagination,
      isLoading: isLoadingUsers,
      isSaving: isUpdatingUser || isDeletingUser,
      showAlertBanner: isLoadingUsersError,
      showProgressBars: isFetchingUsers,
      showColumnFilters: showColumnFilters,
      showGlobalFilter: showGlobalFilter,
    },
  });

  const transformedFilters = columnFilters.map((filter) => ({
    ...filter,
    mode: table.getColumn(filter.id)?.getFilterFn()?.name || "contains",
  }));

  useEffect(() => {
    const transformedFilters = columnFilters.map((filter) => ({
      ...filter,
      mode: table.getColumn(filter.id)?.getFilterFn()?.name || "contains",
    }));

    setFilterModes(transformedFilters);
  }, [columnFilters, table]);

  const someEventHandler = (event: any) => {
    console.info("rows :", table.getRowModel().rows); //example - get access to all page rows in the table
    console.info("row model :", table.getSelectedRowModel()); //example - get access to all selected rows in the table
    console.info("row model :", table.getState().sorting); //example - get access to the current sorting state without having to manage it yourself
  };
  return (
    <div className="table-ad__wrapper" onContextMenu={handleContextMenu}>
      <div className="table-ad__wrapperCard">
        <MaterialReactTable table={table} />

        {/* Context Menu */}
        <Menu
          open={contextMenu !== null}
          onClose={handleClose}
          anchorReference="anchorPosition"
          anchorPosition={
            contextMenu !== null
              ? { top: contextMenu.mouseY, left: contextMenu.mouseX }
              : undefined
          }
        >
          {/* <MenuItem onClick={handlePaste}>Paste</MenuItem> */}
          <MenuItem onClick={handleResizing}>
            {showRowResizing ? "Disable Resizing" : "enable Resizing"}
          </MenuItem>
        </Menu>
      </div>
    </div>
  );
};

//CREATE hook (post new user to api)
function useCreateUser() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (user: User) => {
      //send api update request here
      await new Promise((resolve) => setTimeout(resolve, 1000)); //fake api call
      return Promise.resolve();
    },
    //client side optimistic update
    onMutate: (newUserInfo: User) => {
      queryClient.setQueryData(
        ["users"],
        (prevUsers: any) =>
          [
            ...prevUsers,
            {
              ...newUserInfo,
              id: (Math.random() + 1).toString(36).substring(7),
            },
          ] as User[]
      );
    },
    // onSettled: () => queryClient.invalidateQueries({ queryKey: ['users'] }), //refetch users after mutation, disabled for demo
  });
}

//READ hook (get users from api)

// ContractFormTableComponent.tsx
function useGetData(
  pagination: { pageIndex: number; pageSize: number },
  setTotalCount: any,
  sorting: any,
  dataVersion: number
) {
  return useQuery<{ results: User[]; totalCount: number }>({
    queryKey: ["contracts", pagination, sorting, dataVersion],
    queryFn: async () => {
      let url = `${backendbaseUrl}/paper-app/contracts/?page=${
        pagination.pageIndex + 1
      }&page_size=${pagination.pageSize}`;
      if (sorting.length > 0) {
        const sortParams = `sortField_${sorting[0].id}=${sorting[0].desc}_sorting`;
        url += `&${sortParams}`;
      }

      const response = await axiosInstance.get(url);

      setTotalCount(response.data.count);

      return {
        results: response.data.results as User[],
        totalCount: response.data.count as number,
      };
    },
    refetchOnWindowFocus: false,
  });
}

function useUpdateUser() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (user: User) => {
      // Comprehensive logging
      console.group("🔄 User Update Mutation");
      console.log("Input User Object:", user);

      // Validate basic requirements
      if (!user || !user.id) {
        console.error("❌ Invalid user object:", user);
        throw new Error("User object is invalid or missing ID");
      }

      // Prepare payload - now using the full user object
      const payload = user;

      console.log("📦 Prepared Payload:", payload);

      console.groupEnd();
      try {
        const { data } = await axiosInstance.put(
          `/paper-app/clearers/${payload.id}/`,
          user
        );
        console.log("✅ API Response:", data);
        console.groupEnd();
        return data;
      } catch (error) {
        console.error("❌ API Request Failed:", error);
        throw error;
      }
    },

    // Rest of the mutation remains the same
    onMutate: async (newUserInfo: User) => {
      console.log("🔮 Optimistic Update - New User Info:", newUserInfo);

      // Cancel ongoing queries
      await queryClient.cancelQueries({ queryKey: ["users"] });

      // Snapshot previous data
      const previousUsers = queryClient.getQueryData(["users"]);

      // Optimistically update cache
      queryClient.setQueryData(["users"], (oldData: any) =>
        oldData?.map((prevUser: User) =>
          prevUser.id === newUserInfo.id ? newUserInfo : prevUser
        )
      );

      return { previousUsers };
    },

    onError: (err, newUser, context) => {
      console.error("❌ Update Failed:", err);

      // Rollback optimistic update
      queryClient.setQueryData(["users"], context?.previousUsers);
    },

    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: ["users"] });
    },
  });
}

//DELETE hook (delete user in api)
function useDeleteUser(
  setDataVersion?: React.Dispatch<React.SetStateAction<number>>
) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (userId: string) => {
      try {
        await axiosInstance.delete(
          `${backendbaseUrl}/paper-app/contracts/${userId}/`
        );
        console.log("Deleted userId:", userId);
      } catch (error) {
        console.error("Error deleting user:", error);
        throw error;
      }
      return Promise.resolve();
    },
    onMutate: async (userId: string) => {
      await queryClient.cancelQueries({ queryKey: ["users"] });
      const previousUsers = queryClient.getQueryData(["users"]);
      queryClient.setQueryData(["users"], (prevUsers: any) =>
        prevUsers?.filter((user: User) => user.id !== userId)
      );
      return { previousUsers };
    },
    onError: (err, userId, context) => {
      console.error("❌ Delete Failed:", err);
      queryClient.setQueryData(["users"], context?.previousUsers);
    },
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: ["users"] });
      if (setDataVersion) {
        setDataVersion((prev) => prev + 1); // Increment dataVersion
      }
    },
  });
}

//react query setup in App.tsx
const ReactQueryDevtoolsProduction = lazy(() =>
  import("@tanstack/react-query-devtools/build/modern/production.js").then(
    (d) => ({
      default: d.ReactQueryDevtools,
    })
  )
);

const queryClient = new QueryClient();

export default function App({
  dataVersion,
  setDataVersion,
  setCopiedData,
  setEditMode,
  setEditedData,
}: {
  dataVersion: number;
  setDataVersion: React.Dispatch<React.SetStateAction<number>>;
  setCopiedData: any;
  setEditMode: any;
  setEditedData: any;
}) {
  return (
    <QueryClientProvider client={queryClient}>
      <ContractFormTableComponent
        dataVersion={dataVersion}
        setDataVersion={setDataVersion}
        setCopiedData={setCopiedData}
        setEditMode={setEditMode}
        setEditedData={setEditedData}
      />
      {/* <Suspense fallback={null}>
        <ReactQueryDevtoolsProduction />
      </Suspense> */}
    </QueryClientProvider>
  );
}

const validateRequired = (value: string) => !!value.length;
const validateEmail = (email: string) =>
  !!email.length &&
  email
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );

function validateUser(user: User) {
  return {
    // brokerName: !validateRequired(user.name)
    //   ? "First Name is Required"
    //   : "",
    // name: !validateRequired(user.name) ? "Last Name is Required" : "",
    // email: !validateEmail(user.email) ? "Incorrect Email Format" : "",
  };
}
